import styled from 'styled-components';

export const BadgeStyled = styled.div`
  .badge-title {
    color: ${(props) => props?.theme?.color?.white};
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    background:  ${(props) => props?.theme?.colors?.secondary?.red["700"]};
    padding: 2px 5px;
    border: 1px solid ${(props) => props?.theme?.colors?.secondary?.red["700"]};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
